module.exports = __webpack_public_path__ + "static/media/edit-white.d519d11f.svg";